/**
 * @author Ariel
 * @description 话术管理
 * @Date 2022-03-17
 */
import React from "react";
import { component_tool } from "../../../tool";
import moment from "moment";
import { WizClassifySelect, WizTableForm } from "@/containers/common";
let { WizModal } = component_tool;

const timeTypeEnum = { 1: "月", 2: "年" };
const categoryConfig = WizTableForm.Config.categoryInfo(this, {
  apiParams: { type: 16, state: 1 }
});
const organizationConfig = WizTableForm.Config.organizationBrandNode(this, {
  apiParams: { state: 1, organizationNodeCategory: [2] }
});

let componentName = "verbalTrick";
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "话术",
    name: "name",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "版本号",
    name: "version",
    //searchItem: {},
    tableItem: {}
  },
  {
    title: "标签",
    name: "labelList",
    tableItem: {
      render: (text, record) => {
        return text?.map(item => item.title)?.join() || "";
      }
    }
  },
  {
    title: "标签",
    name: "labelName",
    searchItem: {}
  },
  {
    title: "所属分类",
    name: "categoryId",
    searchItem: {
      type: "diy",
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: "unordered-list",
          title: "所属分类",
          tips: "请选择所属分类"
        },
        treeProps: { checkStrictly: true },
        checkable: false,
        leftViewSpan: 24,
        showSelectList: false
      },
      apiProps: { type: 16 },
      selectProps: {
        placeholder: "请选择所属分类"
      }
    }
  },
  {
    title: "发布日期",
    name: "publishTime",
    searchItem: {
      type: "date~",
      format: "YYYY-MM-DD"
    },
    tableItem: {
      render: (text, record) => {
        return moment(text).format("YYYY-MM-DD");
      }
    }
  },
  {
    title: "有效期",
    name: "effectiveTime",
    tableItem: {
      render: (text, record) => {
        return record?.effectiveTime + timeTypeEnum[record?.timeType || 1];
      }
    }
  },
  {
    title: "是否到期",
    name: "overdue",
    tableItem: {},
    dict: [{ code: 0, codeName: "否" }, { code: 1, codeName: "是" }]
  },
  {
    title: "适用品牌",
    name: "orgList",
    tableItem: {
      render: (text, record) => {
        return text?.map(item => item.name)?.join() || "";
      }
    }
  },
  {
    title: "状态",
    name: "state",
    searchItem: {
      type: "select"
    },
    tableItem: {},
    dict: [{ code: 1, codeName: "启用" }, { code: 0, codeName: "禁用" }]
  },
  {
    title: "适用品牌",
    name: "orgId",
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: "radio"
    }
  },
  {
    title: "是否到期",
    name: "overdue",
    searchItem: {
      type: "select"
    },
    dict: [{ code: 0, codeName: "否" }, { code: 1, codeName: "是" }]
  },
  {
    title: "所属分类",
    name: "categoryName",
    tableItem: {}
  },
  {
    title: "上级分类",
    name: "parentCategoryName",
    tableItem: {}
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        dataFormat: params => {
          let value = Object.assign({}, params);

          let date = value.publishTime;
          if (date && date.length === 2) {
            value.publishStartDate = moment(date[0]).format(
              "YYYY-MM-DD 00:00:00"
            );
            value.publishEndDate = moment(date[1]).format(
              "YYYY-MM-DD 23:59:59"
            );
          }
          if (params.categoryId?.[0]) {
            value["categoryId"] = params.categoryId?.[0];
          }
          return value;
        },
        buttonSort: ["add", "export"],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/verbalTrick/verbalTrickAdd"
              }
            }
          },
          {
            key: "export",
            custom: true,
            params: { icon: "export", children: "导出", type: "export" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters };
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ["update", "enableOrDisable", "preview", "download"],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "设置" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/verbalTrick/verbalTrickUpd"
            }
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用" },
          textFormat: {
            recordKey: "state",
            dirt: { "1": "禁用", "0": "启用" }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content =
                record["state"] === 0
                  ? "您确定要启用该话术吗？"
                  : "话术禁用后，所有模块不能使用该话术，您确定要禁用吗？";
              WizModal.confirm({
                title: "注意",
                content,
                onOk: () => {
                  callback &&
                    callback({
                      id: record["id"],
                      state: record["state"] === 0 ? 1 : 0
                    });
                },
                onCancel() {}
              });
              return null;
            }
          }
        },
        {
          key: "preview",
          name: "WizButton",
          params: { children: "预览" },
          onClick: ({ record }) => {
            window.open(getOssFilePath(record?.fileId + "?preview=true"));
          }
        },
        {
          key: "download",
          name: "WizButton",
          params: { children: "下载" },
          onClick: ({ record }) => {
            window.open(getOssFilePath(record?.fileId + "?preview=false"));
          }
        }
      ],
      rowOperateProps: {
        // width: 80,
        fixed: "right"
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = args => {
  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args
  };
};

export { reduxTemplateConfig, templateConfig };
